import React, { cloneElement, memo } from 'react';
import { Section } from '../ui/Section';
import { UserCheck, Users, Briefcase, TrendingUp } from 'lucide-react';
export function TargetAudience() {
  const audiences = [{
    icon: <UserCheck className="h-8 w-8 text-teal-600" data-id="element-279" />,
    title: 'Oncólogos independientes',
    desc: 'Con consultorio propio, en relación de dependencia parcial o exclusivamente privado.'
  }, {
    icon: <Users className="h-8 w-8 text-teal-600" data-id="element-280" />,
    title: 'Con o sin secretaría',
    desc: 'Funciona tengas equipo administrativo o lo gestiones vos mismo.'
  }, {
    icon: <Briefcase className="h-8 w-8 text-teal-600" data-id="element-281" />,
    title: 'Querés dejar de improvisar',
    desc: "Cansado de sostener todo 'a memoria' y en la cabeza."
  }, {
    icon: <TrendingUp className="h-8 w-8 text-teal-600" data-id="element-282" />,
    title: 'Buscás profesionalizar tu negocio',
    desc: 'Querés tratar tu consultorio con la misma seriedad que tu práctica clínica.'
  }];
  return <Section className="bg-slate-900 text-white" data-id="element-283">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-284">
        <div className="text-center mb-8 md:mb-16" data-id="element-285">
          <h2 className="text-2xl md:text-4xl font-bold mb-3 md:mb-4 text-teal-400" data-id="element-286">
            ¿PARA QUIÉN ES?
          </h2>
          <p className="text-lg md:text-xl text-slate-300" data-id="element-287">
            Diseñado para vos si querés profesionalizar la gestión de tu
            consultorio
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-4 md:gap-8 mb-8 md:mb-12" data-id="element-288">
          {audiences.map((item, i) => <div key={i} className="bg-slate-800 p-6 md:p-8 rounded-2xl border border-slate-700 flex flex-col items-center text-center hover:border-teal-500/50 transition-colors group" data-id="element-289">
              <div className="bg-slate-900 p-3 md:p-4 rounded-full mb-4 md:mb-6 shadow-inner group-hover:scale-110 transition-transform duration-300" data-id="element-290">
                {cloneElement(item.icon as React.ReactElement, {
              className: 'h-6 w-6 md:h-8 md:w-8 text-teal-600'
            })}
              </div>
              <h3 className="text-lg md:text-xl font-bold mb-2 md:mb-3" data-id="element-291">
                {item.title}
              </h3>
              <p className="text-sm md:text-base text-slate-400" data-id="element-292">{item.desc}</p>
            </div>)}
        </div>

        <div className="text-center" data-id="element-293">
          <p className="text-sm md:text-base text-slate-300 mb-3 md:mb-6" data-id="element-294">
            ¿No estás seguro si es para vos?
          </p>
          <p className="text-lg md:text-xl font-bold text-amber-400 hover:text-amber-300 transition-colors cursor-pointer" data-id="element-295">
            Tenés 7 días de garantía →
          </p>
        </div>
      </div>
    </Section>;
}